(function () {
  'use strict';

  angular.module('app').component('measurementUnitList', measurementUnitList());

  function measurementUnitList() {
    return {
      bindings: {
        measurementUnits: '=',
        meta: '<',
        totalItems: '=',
        loadingItems: '<',
        onShowMeasurementUnit: '&',
      },
      controller: MeasurementUnitListComponent,
      controllerAs: 'vm',
      templateUrl:
        './app/ajs/measurement-units/measurement-unit-list/measurement-unit-list.component.html',
    };
  }

  MeasurementUnitListComponent.$inject = [
    'UtilService',
    'AbilityService',
    'MeasurementUnitService',
  ];

  function MeasurementUnitListComponent(UtilService, AbilityService, MeasurementUnitService) {
    var vm = this;

    vm.permissions = {
      canShow: AbilityService.can('show_measurementunit_accountadmin'),
      canUpdate: AbilityService.can('update_measurementunit_accountadmin'),
      canDestroy: AbilityService.can('destroy_measurementunit_accountadmin'),
    };

    vm.UtilService = new UtilService(vm);

    vm.filterCriteria = MeasurementUnitService.getFilterCriteria();

    // Methods
    vm.fetchResult = fetchResult;
    vm.refresh = refresh;
    vm.selectPage = selectPage;
    vm.onSort = onSort;
    vm.showMeasurementUnit = showMeasurementUnit;
    vm.changeMeasurementUnitStatus = changeMeasurementUnitStatus;
    vm.deleteMeasurementUnit = deleteMeasurementUnit;

    // Initializers
    getProductTypes();

    function getProductTypes() {
      vm.productTypes = vm.UtilService.getProductTypes();
    }

    function fetchResult() {
      vm.loadingItems = true;
      MeasurementUnitService.getMeasurementUnits(vm.filterCriteria).then(function (data) {
        vm.measurementUnits = data.items;
        vm.meta = data.meta;

        vm.totalItems = vm.meta.totalItems;

        vm.loadingItems = false;
      });
    }

    function refresh() {
      vm.filterCriteria = MeasurementUnitService.getFilterCriteria();
      fetchResult();
    }

    function selectPage() {
      vm.filterCriteria.offset = (vm.filterCriteria.page - 1) * vm.meta.itemsPerPage;
      fetchResult();
    }

    function onSort(sortedBy, sortDir) {
      vm.filterCriteria.page = 1;
      vm.filterCriteria.sortDir = sortDir;
      vm.filterCriteria.sortedBy = sortedBy;

      fetchResult();
    }

    function showMeasurementUnit(measurementUnit, mode) {
      if (!vm.permissions.canShow) {
        return;
      }

      vm.onShowMeasurementUnit({ item: measurementUnit, mode: mode });
    }

    function changeMeasurementUnitStatus(measurementUnit) {
      if (measurementUnit.predefined) {
        return;
      }

      MeasurementUnitService.changeMeasurementUnitStatus(measurementUnit);
    }

    function deleteMeasurementUnit(measurementUnit) {
      if (measurementUnit.predefined) {
        return;
      }

      MeasurementUnitService.deleteMeasurementUnit(measurementUnit, fetchResult);
    }
  }
})();
